import * as yup from 'yup'
import { storeFormFields as SFF } from 'components/storeManagement/utils'
import { NO_SPECIAL_CHAR } from 'utils/constants'
import { checkLastChar } from './aggregatorSchema'

export const storeAggregatorSchema = yup.object().shape({
  // Aggregator
  aggregatorId: yup
    .string()
    .trim()
    .required('Aggregator is required field')
    .test('last-char-check', 'Please Enter Valid Aggregator ID.', (value) =>
      checkLastChar(value),
    )
    .matches(NO_SPECIAL_CHAR, 'Please Enter Valid Aggregator ID'),
  [SFF.STORE_ID.key]: yup
    .string()
    .trim()
    .required(`${SFF.STORE_ID.label} is required field`)
    .test(
      'last-char-check',
      `Please Enter Valid ${SFF.STORE_ID.label}.`,
      (value) => checkLastChar(value),
    )
    .matches(NO_SPECIAL_CHAR, `Please Enter Valid ${SFF.STORE_ID.label}`),
})
